<div class="container-fluid">
  <div class="row">
    <div *ngFor="let download of downloads" class="col-md-6">
      <div *ngIf="download.downloadFiles">
        <div class="card">
          <div class="card-header">
            <h5>{{ download.categoryName }}</h5>
            <div class="card-header-right"></div>
          </div>
          <div class="card-block table-border-style pt-0">
            <div id="description" class="pb-0 pt-1 ps-1">{{ download.description }}</div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr class="text-start">
                  <th>{{'doctrine.download.description'|translate}}</th>
                  <th>{{'global.action'|translate}}</th>
                </tr>
                </thead>
                <tbody *ngIf="download.downloadFiles">
                <tr *ngFor="let file of sertFiles(download.downloadFiles)" class="p-0">
                  <th class="p-0">{{ file.name }}</th>
                  <td class="p-0">
                    <a href="{{apiUrl+'/download/?path='+file.image.path+'&filename='+file.image.filename}}"
                       (click)="downloadFile($event,file.image)"
                       target="_blank">{{'global.download'|translate}}</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
